import React from "react";
import PharmacyTabs from "./PharmacyTabs";

function PharmacyExpenses() {
  return (
    <>
      <div className="flex flex-col gap-3 h-[94%]">
        <div className="h-full">
          PharmacyExpenses
        </div>
      </div>
    </>
  );
}

export default PharmacyExpenses;